import React from 'react'
import loadingGif from '../../images/loader.gif';

const CustomLoading = () => {

    return (
        <>

            <div className="w-100 h-100 background-dim">
                <div className="d-flex justify-content-center align-items-center">
                    <div className="loading-img">
                        <img src={loadingGif} alt="Success Gif" className="img-fit loader-img" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default CustomLoading